import React from "react";
import * as Icon from "react-feather";
import clsx from "clsx";
import "../../../afs-walkthrough.css";
import WComponent from "../../../../../../common/WComponent";

function collectEscalatedItems(clientId, crossCheckResults) {
	let items = [];
	for (let check of (crossCheckResults || [])) {
		let storageKey = "exec_steps_" + (clientId || "0") + "_" + (check.id || "unknown");
		let userResponses = {};
		try { let saved = localStorage.getItem(storageKey); if (saved) userResponses = JSON.parse(saved); } catch (e) {}

		for (let stepId of Object.keys(userResponses)) {
			if (userResponses[stepId] === "escalate") {
				let stepDef = (check.execution_step_statuses || []).find(function (s) { return s.id === stepId; });
				items.push({
					escalationKey: check.id + "__" + stepId,
					checkId: check.id,
					checkLabel: check.label,
					section: check.section || "Other",
					stepId: stepId,
					stepLabel: stepDef ? stepDef.label : stepId,
					detail: check.detail || "",
					tier: check.tier,
				});
			}
		}
	}
	return items;
}

class PartnerReviewSection extends WComponent {
	state = { editingNote: {} };

	render() {
	let { clientId, crossCheckResults, partnerReviews, onPartnerReviewChange } = this.props;
	let escalatedItems = collectEscalatedItems(clientId, crossCheckResults);

	let { editingNote } = this.state;

	const handleAction = (escalationKey, status) => {
		let note = editingNote[escalationKey] || (partnerReviews[escalationKey] ? partnerReviews[escalationKey].note : "") || "";
		onPartnerReviewChange(escalationKey, { status: status, note: note, timestamp: new Date().toISOString() });
	};

	const handleNoteChange = (escalationKey, value) => {
		this.setState(function (prev) { return { editingNote: { ...prev.editingNote, [escalationKey]: value } }; });
	};

	if (escalatedItems.length === 0) {
		return (
			<div className="afs-review__partner-empty">
				<Icon.CheckCircle size={20} color="#4caf50" />
				<span>No items have been escalated for partner review.</span>
			</div>
		);
	}

	// Group by section
	let grouped = {};
	for (let item of escalatedItems) {
		if (!grouped[item.section]) grouped[item.section] = [];
		grouped[item.section].push(item);
	}

	return (
		<div className="afs-review__partner-section">
			{Object.keys(grouped).map(function (section) {
				return (
					<div key={section} className="afs-review__partner-group">
						<div className="afs-review__partner-group-header">{section}</div>
						{grouped[section].map(function (item) {
							let review = partnerReviews[item.escalationKey];
							let isReviewed = review && review.status === "reviewed";
							let isAction = review && review.status === "action_required";
							let noteValue = editingNote[item.escalationKey] !== undefined ? editingNote[item.escalationKey] : (review ? review.note || "" : "");

							return (
								<div key={item.escalationKey} className={clsx("afs-review__partner-item", isReviewed && "afs-review__partner-item--reviewed", isAction && "afs-review__partner-item--action")}>
									<div className="afs-review__partner-item-header">
										<div className="afs-review__partner-item-title">
											{isReviewed && <Icon.CheckCircle size={14} color="#2e7d32" />}
											{isAction && <Icon.AlertTriangle size={14} color="#e67e22" />}
											{!review && <Icon.AlertCircle size={14} color="#7a8aaa" />}
											<span className="afs-review__partner-item-check">{item.checkLabel}</span>
										</div>
										{review && (
											<span className="afs-review__partner-timestamp">
												{review.status === "reviewed" ? "Reviewed" : "Action Required"} — {new Date(review.timestamp).toLocaleDateString("en-CA")}
											</span>
										)}
									</div>
									{item.detail && <div className="afs-review__partner-item-detail">{item.detail}</div>}
									<div className="afs-review__partner-item-step">
										<Icon.CornerDownRight size={12} color="#7a8aaa" />
										<span>Escalated from: {item.stepLabel}</span>
									</div>
									<textarea
										className="afs-review__partner-note"
										placeholder="Partner notes..."
										value={noteValue}
										onChange={function (e) { handleNoteChange(item.escalationKey, e.target.value); }}
									/>
									<div className="afs-review__partner-actions">
										<button
											className={clsx("afs-review__partner-btn", isReviewed && "afs-review__partner-btn--active")}
											onClick={function () { handleAction(item.escalationKey, "reviewed"); }}
										>
											<Icon.Check size={12} /> Reviewed
										</button>
										<button
											className={clsx("afs-review__partner-btn", isAction && "afs-review__partner-btn--active")}
											onClick={function () { handleAction(item.escalationKey, "action_required"); }}
										>
											<Icon.Flag size={12} /> Action Required
										</button>
									</div>
								</div>
							);
						})}
					</div>
				);
			})}
		</div>
	);
	}
}

export { collectEscalatedItems };
export default PartnerReviewSection;
